import type { Control, FieldErrors, UseFormRegister } from 'react-hook-form';
import { Card } from '@/components/ui/Card';
import { UI_STRINGS } from '@/lib/constants/ui-strings';
import type { InvestorProfileFormValues } from './schema';
import { PreferencesEditor } from './PreferencesEditor';

const S = UI_STRINGS.INVESTOR_PROFILE;

interface PreferencesSectionProps {
  control: Control<InvestorProfileFormValues>;
  register: UseFormRegister<InvestorProfileFormValues>;
  errors?: FieldErrors<InvestorProfileFormValues>;
}

/**
 * The investment preferences fields of the "What we invest in" panel: ticket
 * size, revenue, stages, market models, lead or follow, deployment and other
 * criteria (US-040/US-101, FR-175). The read view is `WhatWeInvestInCard`.
 */
export function PreferencesSection({ control, register, errors }: PreferencesSectionProps) {
  return (
    <Card title={S.PREFERENCES} subtitle={S.PREFERENCES_HINT} headerDivider hoverEffect={false}>
      <PreferencesEditor control={control} register={register} errors={errors} />
    </Card>
  );
}
